/**
 * Users/Accounts Controller
 *
 * 
 */
 
 // the constructor for this object
 function UsersManageAccountsController() { }
 
// the object
UsersManageAccountsController.prototype = {
    constructor: UsersManageAccountsController,
    
    // initialize the controller
    init: function() 
    {
        // the user must be logged in to access this page
        PortalMain.authRedirect();
        
        PortalHelper.debugMessage('Manage Accounts Controller Initialized');
    },

    // run the controller
    run: function()
    {
        // register the events used by this controller
        this._registerEvents();
        
        this._populateAccounts();
        
        PortalHelper.debugMessage('Accounts Controller Ran');
    },

    // register the javascript events
    _registerEvents:  function() 
    {   
        $('#accounts-form').on('submit', function(e) {
            e.preventDefault();
            
            PortalMain.UsersManageAccountsController._updateAccounts();
        });
    },
    
    // populate the accounts of the authenticated user
    _populateAccounts: function()
    {
        //var accounts = PortalMain.PortalAccounts.getAccounts();
        var accounts = PortalMain.PortalAccounts.getAdminAccounts();
        
        // add the new tickets to the DOM
        for (var i in accounts) {
            var account = accounts[i];
            var newEntry = $('.accounts .clone-source').clone();
            newEntry.removeClass('clone-source');
            
            // set the row account id
            $(newEntry).attr('data-account-id', account.account_id);
            
            // apply the account number
            $('.account-number', newEntry).html(account.account_number);
            
            // apply the account name
            $('.account-name', newEntry).html(account.name); 
            
            // apply the account id
            $('.account-2fa', newEntry).val(account.account_id);  
            if (account.is_2fa_required) {
                $('.account-2fa', newEntry).prop('checked', true);
            }
            
            // add to to the table
            $('.accounts tbody').append(newEntry);
        }
        
        PortalHelper.loadingOverlay('#accounts-form', false);
        
        PortalHelper.enableButton('#update-accounts');
    },
    
    // remove the selected accounts 
    _updateAccounts: function()
    {
        PortalHelper.disableButton('#update-accounts');
        PortalHelper.loadingOverlay('#accounts-form', true);
        
        // get all the accounts to remove
        var updateAccounts = [];
        var formAccts = $('#accounts-form .account-2fa:checked');
        formAccts.each(function(i, e){
            var accountId = $(this).val();
            updateAccounts.push({
                account_id: accountId
            });
        });
        
        var updateAccountsRequest = new PortalRequest();
        updateAccountsRequest.successElement = '.form-success';
        updateAccountsRequest.errorElement = '.form-errors';
        updateAccountsRequest.makeRequest(
            '/accounts/update-accounts',
            {
                accounts: updateAccounts
            },
            function(updateAccounts) {
                PortalMain.UsersManageAccountsController._clearAccountRows(updateAccounts);
                PortalHelper.loadingOverlay('#accounts-form', false);
                PortalHelper.enableButton('#update-accounts');
                
                // ensure the login data updates on next page load
                PortalMain.PortalLogin.forceLoginUpdateOnNextLoad();
            },
            function(response) {
                PortalHelper.loadingOverlay('#accounts-form', false);
                PortalHelper.enableButton('#update-accounts');
            }
        )
    },
    
    // remove the account rows
    _clearAccountRows: function(updateAccounts)
    {
        for (var i in updateAccounts) {
            var accountId = updateAccounts[i];
            
            $('.accounts tr[data-account-id=' + accountId + ']').remove();
        }
    },
    
 }
